import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getUserSnapshot } from '../utils/sessionUser';
import { isUSUserFlag } from '../utils/dateFormat';
import { weightInKgFlag } from '../utils/weightConversion';

const UserPreferencesContext = createContext({
  isUSUser: false,
  weightInKg: true,
  setIsUSUserFromUser: () => {},
  setWeightInKgFromUser: () => {},
  reloadPreferences: async () => {},
});

export function UserPreferencesProvider({ children }) {
  const [isUSUser, setIsUSUser] = useState(false);
  const [weightInKg, setWeightInKg] = useState(true);

  const reloadPreferences = useCallback(async () => {
    const snap = await getUserSnapshot();
    setIsUSUser(isUSUserFlag(snap));
    setWeightInKg(weightInKgFlag(snap));
  }, []);

  useEffect(() => {
    void reloadPreferences();
  }, [reloadPreferences]);

  const setIsUSUserFromUser = useCallback((user) => {
    setIsUSUser(isUSUserFlag(user));
    setWeightInKg(weightInKgFlag(user));
  }, []);

  const setWeightInKgFromUser = useCallback((user) => {
    setWeightInKg(weightInKgFlag(user));
  }, []);

  return (
    <UserPreferencesContext.Provider
      value={{
        isUSUser,
        weightInKg,
        setIsUSUserFromUser,
        setWeightInKgFromUser,
        reloadPreferences,
      }}
    >
      {children}
    </UserPreferencesContext.Provider>
  );
}

export function useUserPreferences() {
  return useContext(UserPreferencesContext);
}
